import ProtectedRoute from 'auth/ProtectedRoute';
import PatientCentralDashboard from 'components/dashboard/Dashboard';
import { PatientCentralRefDataContextProviderWrapper } from 'components/patient-entry/PatientCentralRefDataContext';
import React, { Fragment } from 'react';
import { Switch } from 'react-router';

const DashboardHome = () => (
    <Fragment>
      <PatientCentralRefDataContextProviderWrapper>
        <Switch>
          <ProtectedRoute path="/dashboard" exact component={PatientCentralDashboard}/>
        </Switch>
      </PatientCentralRefDataContextProviderWrapper>
    </Fragment>
);

export default DashboardHome;
